import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = null;

export const userToken = createSlice({
    name: "userToken",
    initialState: {
        value: initialStateValue,
    },
    reducers: {
        setUserTokenReducer: (state, action) => {
            state.value = action.payload;
        },
        clearUserTokenReducer: (state) => {
            state.value = initialStateValue;
        },
    },
});
export const { setUserTokenReducer, clearUserTokenReducer } = userToken.actions;
export default userToken.reducer;